import { render, staticRenderFns } from "./EmployerMatchContribBasedYosRadio.vue?vue&type=template&id=fdc391fc&"
import script from "./EmployerMatchContribBasedYosRadio.vue?vue&type=script&lang=js&"
export * from "./EmployerMatchContribBasedYosRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports